define(function(require) {

    function _getRepresentationColor(value, themeIdx) {
        return window.cartovista.externalInterface.map.activeThemeSet.getThemeByIndex(themeIdx).colorTheme.getRepresentation(value).color.rgba;
    };
    var DomUtil = require("cartovista").DomUtil;
    return {
        ID: "Res_MRC_1",
        THEMESETS_IDS: ["Res_MRC_1"],
        RIGHT_PANEL: {
            DEFAULTS: {
                ACTIVE_LAYER_ID: "GEO09E05_MRC_GEN",
                GRAPH_TYPE: "bar",
                GRAPH_DATA_ORIENTATION: "columns",
                PADDING: {"left": 30, "top": 0, "right": 15, "bottom": 0},
                HEIGHT_FN: function() { 
                    if (!DomUtil.isResponsiveUI()) return $(".cv-right-top-pane").height() - 100;
                    else return 315;
                },
                WIDTH_FN: function() { 
                    if (!DomUtil.isResponsiveUI()) return $(".cv-right-top-pane").width() - 30;
                    else return $("#BbGraphs_topPanel_container").width() - 20;
                },
                DATA_AUTO_SORT: "asc",
                X_AXIS_LABEL: {"text": "MRC", "position": "outer-right"},
                X_AXIS_TICK_VALUES: [],
                Y_AXIS_LABEL: "%",
                Y_AXIS_MAX_VALUE : 95,
                DATA_COLORS: undefined,
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + "%"; }
            },
            GRAPHS: [
                {
                    TITLE: "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec, en fonction du sexe, {{TEXT}} (%)",
                    DATA_SOURCES: [
                        {
                            LAYER_ID: "GEO09E05_MRC_GEN",
                            DATATABLE_ID: "t_GEO09E05_MRC_GEN_residence",
                            DATACOLUMNS_IDS: ["TX_SANS_D_PROV_M_{{VALUE}}", "TX_SANS_D_PROV_F_{{VALUE}}"],
                            NO_SELECTION_SHOW_ALL_FEATURES: true
                        }
                    ],
                    X_DATA_NAMES: ["Sexe masculin", "Sexe féminin"],
                     DATA_COLORS: {"Sexe masculin" : "#095797", "Sexe féminin": "#68CEBA"},
                },
                {
                    TITLE: "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec, sexes réunis, {{TEXT}} (%)",
                    DATA_SOURCES: [
                        {
                            LAYER_ID: "GEO09E05_MRC_GEN",
                            DATATABLE_ID: "t_GEO09E05_MRC_GEN_residence",
                            DATACOLUMNS_IDS: ["TX_SANS_D_PROV_T_{{VALUE}}"],
                            NO_SELECTION_SHOW_ALL_FEATURES: true
                        }
                    ],
                    DATA_NAMES: {"FGJ": "Municipalité régionale de comté"},
                    X_DATA_NAMES: ["Municipalité régionale de comté"],
                    DATA_COLORS: {"Municipalité régionale de comté": "#000000"},
                    ON_RENDERED_FN: function(graph) {
                        _.forEach(graph.data("Municipalité régionale de comté")[0].values, function(valueObj) {
                            graph.$.main.select(".bb-bar-" + valueObj.index).style("fill", _getRepresentationColor(valueObj.value, 0));
                        }.bind(this));
                    },
                    TOOLTIP_NAME_FN: function(name, graph) { return "Ensemble du Québec"; },
                    TOOLTIP_ON_SHOWN_FN: function(graph) {
                        var value = graph.data("Municipalité régionale de comté")[0].values[graph.categories().indexOf(graph.$.tooltip.select("th").text())].value;
                        graph.$.tooltip.select("td.name span").style("background-color", _getRepresentationColor(value, 0));
                    }
                }
            ]
        }
    };
});
